// 「オールイン宣言」v1 — 日本語版
// 構造は MANIFESTO_ZH と完全に対応。
// 著者：ALLIN コミュニティ

export const MANIFESTO_JA = {
  meta: {
    title: 'オールイン宣言',
    subtitle: '一つのことに全部を賭けた人々への覚え書き',
    author: 'ALLIN コミュニティ',
    edition: '初版 · 2026年春',
  },
  sections: [
    {
      id: 'preface',
      kind: 'preface',
      number: '',
      title: 'まえがき',
      pullQuote: 'オールインは、この世代で最も誤解されたロマンだ。',
      paragraphs: [
        '一行で開始したい——オールインは、この世代で最も誤解されたロマンだ。',
        'これはホワイトペーパーではない。',
        'ホワイトペーパーは、プロトコル設計、コンセンサスの仕組み、トークノミクスの精緻な美しさを語るだろう。四段階のロードマップを描き、どの一歩も月へと続いているように見せるだろう。私たちにそれは書けない。$ALLIN は L1 でもなく、DeFi プロトコルでもなく、「技術的ブレイクスルー」も持たない——コントラクトはただの BEP-20、余分な require 文一つすらない地味さだ。',
        'ではなぜトークンを発行するのか？',
        '何十年も存在しながら、一度もきちんと名づけられてこなかったある精神に、道標を立てたいからだ。それはバフェットに、段永平に、2008年のマスクに、雷軍の小米粥に、趙長鵬が売った上海のマンションに宿っている。国も業界も問わず、偉大な決断の裏側には必ず現れてきたものだ。',
        '私たちはそれを**オールイン**と呼ぶ。',
        'トークンは、この種のコンセンサスに値段を付け、所有権を確定し、台帳に刻み込む——もっとも速い容器だ。この『オールイン宣言』、そしてそれが代表するこのプロジェクトは、一つのことに全部を賭けた者たちへの記念碑であり、いまその縁で躊躇している者たちへの手紙でもある。',
        '読み終わって「これは私のことだ」と思ったなら——テーブルへ来てほしい。',
      ],
      sign: '——ALLIN コミュニティ',
    },

    {
      id: 'ch1',
      kind: 'chapter',
      number: 'I',
      title: 'なぜ ALLIN なのか',
      paragraphs: [
        '私たちはヘッジを奨励する時代を生きている。',
        'ヘッジファンドが扱うのは資金だが、「ヘッジ」という発想はとうに金融の外にあふれ、世俗的な処世術になった。投資は分散しろ。一社にオールインするな。人間関係は予備を用意しろ。時間は複数のプロジェクトに割り振れ。各時代に金科玉条がある——この世代の金科玉条は「すべての卵を一つのカゴに入れるな」だ。',
        '安全に聞こえる。代償は、どのカゴも満たないことだ。',
        '分散に反対しているのではない。何をしているのか分からない人にとって、分散は最も責任ある選択だ。それは致命的にならない下方境界を提供する。問題は、分散が同時に並外れた上方境界をも与えないことにある——人生を平均回帰の商品に変えてしまう。',
        'この世代の真の勝者で、分散から生まれた者は一人もいない。',
        'バフェットのバークシャーは、最も収益が出た期間、ポートフォリオの 70% を 10 銘柄未満に集中させていた。その 10 銘柄のうち一つが半分近くを占めていた。これは分散ではない——研究を尽くした上での集中だ。段永平は 2001 年、NetEase に全資産を賭け、3年で 50倍を手にした。雷軍は 40歳で経済的自由を得たあと、複数のトラックに小さく賭ける天使投資家を続けず、自ら一社に飛び込み、あの一杯の小米粥を飲んだ。マスクは 2008 年、ロケットを最後にもう一度だけ打ち上げられる現金しか残っていなかったとき、それを ABC 三段の「リスクテスト」に分けず、第四の打ち上げに直接賭けた。',
        '彼らが共有しているのは、神秘めいたギャンブラーの気質ではない。むしろ逆だ——彼らは皆、その時点でその業界において最も研究が深く、最も情報が揃い、最もリスク評価が厳密な人物の一人だった。彼らがオールインできたのは、見極めていたからだ。',
      ],
      pullQuote: 'オールインは運の賭けではない。見極めた後に、すべてのチップを押し出す勇気だ。',
      paragraphsAfterQuote: [
        'だがこの言葉は過去十年で何度も汚名を着せられてきた。「オールイン」が多くの耳には「ギャンブラー」「個人投資家の衝動」「全部突っ込んでゼロになる」と等価に響く。これは大きな意味のすり替えだ。**真のオールイン者は決して運に頼らない。彼らが頼るのは、研究の深さと、それを実弾に変える勇気だ**。運に頼る側はまったく別の集団であり、それは「ギャンブラー」と呼ばれる——彼らもしばしばオールインするが、自分が根本的に理解していないものに賭けるため、ゼロになるのは必然だ。',
        'ALLIN がまずやりたいのは、「オールイン」という言葉をギャンブラーから取り戻すことだ。',
        'もう一つは、ビジネスエリートの専有物だった辞書から取り出して、すべての人に渡すことだ。',
        '起業家だけがオールインできるのではない。一人のエンジニアが大手を辞めて自分のオープンソースに集中する——それはオールインだ。一人の学生が大学で一つの分野だけを学び、すべての時間を AI 研究に注ぐ——それはオールインだ。一つの家族が北京の家を売ってニュージーランドの教育に全額を投じる——それもオールインだ。一人の普通の人が余暇と貯蓄をすべて一つのことに十年間注ぐ——それもまたオールインだ。',
        'オールインは業界、資産規模、身分のどれにも属さない。それはひとつの姿勢にだけ属する：**研究を尽くし、全部を押し、結果を引き受ける**。',
        'ではなぜトークンなのか？',
        'なぜならトークンは、この世代が持つ最速のコンセンサス容器だからだ。一篇の文章が圏層を形作るのに数年かかる。一冊の本が文化を形作るのに十年かかる。一つの宗教が安定するのに百年かかる。だがトークン——透明で、取引可能で、オンチェーンで証明され、コンセンサスに値段がつくもの——は、数ヶ月で人々を集め、互いを見つけ、互いを確認させる。',
        '私たちは $ALLIN が「実用的な問題」を解くことを期待していない。このトークンには実用機能がない。それは記念碑であり、合言葉であり、名簿だ——名簿に載るのは、自分の人生で一つのことに全部を賭けたすべての人だ。',
        '最後に一線を引く：ALLIN は Trump テーマでも、Doge の続編でも、トレンドにあやかった meme でもない。それは中国語圏の文脈において、**オールインの精神**に対する正式な記念碑だ。ロゴの拳を上げる金色の Doge は、Trump のポーズを借りたものではない——あれ自体が、この世代がもっともよく知る「私は見極めた、賭けに出る」の身体言語だ。',
        'Doge とその動きは共有しても、精神はもっと深い場所から来ている。',
      ],
    },

    {
      id: 'ch2',
      kind: 'chapter',
      number: 'II',
      title: '三つの精神原則',
      paragraphs: [
        'プロジェクトのすべての判断、すべての決定、すべての収録基準は、この三条から来ている。',
      ],
      subsections: [
        {
          id: 'ch2-1',
          number: 'I',
          title: '見極めたら、オールイン',
          paragraphs: [
            'この一条が「研究」と「賭け」の関係に対する見方を決める。',
            '業界には二つの主流がある。一つはバフェットの「安全マージン」——内在価値を大きく下回る価格でしか買わず、十分な緩衝を残す。もう一つは段永平の「やらないリスト」——一生やらないことを書き出し、残った領域だけを研究範囲にする。表面は二つの方法に見えるが、本質は同じ——重大な決断の前に「理解できないもの」を全部排除する、という行為だ。',
            '排除を終えると、面白いことが起こる：賭けられる対象が極端に少なくなる。',
            'どれくらい少ないか？バフェットは最も儲けた数十年の間、年に1〜2件しか本当に重大な賭けをしなかった。段永平は人生で重大な決断は5回を超えないと公言している。彼らが怠惰だからではない——**本当に理解できる対象は、もともと多くない**ことを知っているからだ。',
            'この事実は逆向きの推論を生む——本当に理解したものに対して、分散は自己への裏切りである。',
            'NetEase を研究し尽くし、現金準備が時価総額を超えていることを確認したなら、なぜ 10% しか買わないのか？すでに 90% の研究は終わっている。残り 10% を投じない理由は何か？自分の研究を疑っているのでなければ——疑っているなら、「分散」で自分の不確実性を覆い隠すのではなく、もっと研究すべきだ。',
            'ケリー基準はこのことに数学的根拠を与える。勝率と倍率が分かっているとき、最適な賭け率は通常の投資家が出せる金額をはるかに上回ることが多い。勝率 60%、倍率 1.5:1 のチャンスでは、ケリーは資金の 33% を勧める——5% でも 10% でもない。',
            '「見極めたらオールイン」と言うとき、衝動を煽っているのではない。次の二種類の人を退場させたいのだ：',
          ],
          list: {
            items: [
              '**第一に、本当は見極めていないのに FOMO で賭ける人。** それはギャンブルだ。研究に戻れ。',
              '**第二に、見極めたのに少ししか賭けない人。** それは臆病だ。確信を換金しろ。',
            ],
          },
          paragraphsAfterList: [
            'その間にある狭い道だけが、オールインだ。',
            '「見極めた」と判断する最低ラインを、三つ提案する：',
          ],
          checklist: {
            items: [
              '5 分で、その分野を知らないが頭の良い人に、要点を説明できる。',
              'この賭けが失敗する三つの経路を挙げ、それぞれの確率を見積もれる。',
              '最悪の場合でもあなたの生活は続けられる。「返せない借金」も「取り戻せない関係」も生まれない。',
            ],
          },
          paragraphsTail: [
            '三つ目が特に重要だ。私たちは破滅的な博打を奨励しているのではない——オールインと無謀な博打の境界を引いている。本物のオールイン者が賭けるのは「失っても耐えられる全部」であって、「借りられる全部」ではない。これは自分の生活に対する誠実な抑制だ。',
          ],
        },

        {
          id: 'ch2-2',
          number: 'II',
          title: '賭けの結果を受け入れる',
          paragraphs: [
            'この一条が、自分自身、ホルダー、市場に対する姿勢を決める。',
            'ALLIN はリターンを約束しない。',
            'もう一度言いたい——ALLIN は**リターンを約束しない**。コントラクトにはステーキング APY もなく、買い戻し焼却の機械もなく、定期分配もない。私たちはどの KOL の動画でも「100x が来る」とは言わない。X のどの投稿にも「目標価格」を描かない。',
            '私たちが約束するのは一つだけ——真実だ。',
            'コントラクトは真実だ——LP は永久に焼却され、オンチェーンで検証できる。配分は真実だ——チーム保有もアドバイザーアンロックもない。物語は真実だ——収録されたすべてのオールイン事例は、公開された検証可能な資料に基づく。それだけだ。',
          ],
          pullQuote: '私たちは夢を売らない。誠実な契約だけを差し出す——見えるものが、すべてだ。',
          paragraphsAfterQuote: [
            'これは二つの業界慣性を能動的に拒むことを意味する。',
            '一つ目は「ロードマップの魔法」だ。多くのトークンプロジェクトは Phase 1 / 2 / 3 / 4 を描き、各段階が精密でリズミカルで止められないものに見える。**私たちには Phase 4 がない**。私たちは現時点で実行できることだけを約束し、一年後に何が起きるかは約束しない——コミュニティのコンセンサスそのものが流動的だからだ。来年の進路は来年のコミュニティが決めるものであって、今日ドキュメントを書いている人間が決めるものではない。プロフェッショナルに聞こえないかもしれないが、誠実だ。',
            '二つ目は「コンセンサスの維持」だ。meme が走り出すと、運用側は通常こうする：群を作り、買いを呼びかけ、買い板を仕込み、感情を安定させ、価格をあまり戻さないようにする。私たちはやらない。**ALLIN の値動きは、コミュニティの今この瞬間の信仰の強度をそのまま映す**——コンセンサスが強ければ価格は上がり、弱ければ下がる。私たちは弱った瞬間にいかなる手段でも「下支え」しない。下支えはホルダーへの最大の不誠実だ。「まだ守る人がいる」という幻想を作り出し、最後にその幻想を信じた人が買い手になる。',
            '結果を受け入れることの中心は、これがゼロになり得ると認めることだ。',
            '必ずゼロになると言っているのではなく、私たち——プロジェクト側、コアホルダー、コミュニティ貢献者——がその可能性を 100% 知った上で、それでもテーブルに残る選択をしているということだ。この「知った上で残ること」だけが、ALLIN にとって唯一信頼に足る堀である。',
            'ホルダーへ：失っても耐えられる金額で賭けてほしい。「耐えられる」とは金額のことではない——その金がゼロになっても、生活、関係、健康に質的な変化が起きないかどうかだ。返せない金で賭けているなら、あなたはこの宣言の読者ではない。あなたはギャンブラーだ。離れてほしい。',
            '公に負けることもまた誇りだ。',
            'もしいつか $ALLIN がゼロになったら、コミュニティは最後の記録を公開する——収録されたすべての物語、すべての貢献者、すべてのオンチェーンデータを並べてアーカイブする。こっそり消えることはない。改名して再起動することもない。別のプロジェクトにロンダリングされることもない。**負けた物語は、勝った物語と同じだけ記録される価値がある**——どちらも等しく、その瞬間に全部を賭けた人の勇気を真実に背負っているからだ。',
          ],
        },

        {
          id: 'ch2-3',
          number: 'III',
          title: '長期主義者とだけ歩む',
          paragraphs: [
            'この一条が、誰を引き寄せたいか、誰から離れたいかを決める。',
            '最も誤解されやすいのは、「長期主義」という四文字だ。いまや乱用されすぎてほとんど意味を失っている——30%下げた株を塩漬けにして「長期保有」と呼ぶ。7年伸びない仕事から離れず「長期投入」と呼ぶ。とうに互いを消耗させているだけの関係を解消せず「長期コミットメント」と呼ぶ。これらは違う。',
          ],
          pullQuote: '長期主義は受動的な待機ではない。毎年が最後の年かもしれないと思いながら、それでも賭け続けることを選ぶ姿勢だ。',
          paragraphsAfterQuote: [
            '能動的で、絶えず再評価され、いつでも撤退できるが撤退しないことを選んでいる姿勢だ。沈没コストのために動かないだけなら、それは長期主義ではない。それは慣性だ。',
            'ALLIN が探す道連れは、「オールイン」を一回限りのイベントではなく、生き方として扱う人だ。それはつまり：',
          ],
          checklist: {
            items: [
              '自分の研究を継続的に疑い、反証を見たら調整できる人。',
              '勝ったときに大言を吐かず、負けたときに姿を消さない人。',
              '全部を賭ける。だが常に「次に最も重要な一件」に賭け、過去の一件にとどまらない人。',
              '他の長期主義者に対して、たとえトラックや判断が違っても、自然な敬意を持つ人。',
            ],
          },
          paragraphsTail: [
            'だからこそ ALLIN の中心的なコンテンツは、巨人たちのオールイン物語の収録だ。これらは「信仰マーケティング」のための素材ではない——私たちと道連れに向けた覚え書きだ：**オールインは特定の時代だけのものではない。どの世代にもあり、どの業界にもある**。',
            '私たちは長い名簿を残したい。',
            '名簿に載るのは、任正非のような産業家、バフェットのような資本家、マスクのようなエンジニア、孫宇晨のような暗号資産プレイヤー、王興のような連続起業家かもしれない。あるいは、まだ私たちが知らない、どこかの小さな町のアパートで全部の時間を一つのことに注いでいる若者かもしれない。この名簿は国籍、業界、階級を問わない——唯一の入場券は、一つのことに全部を賭けたという事実だ。',
            'いまそういう一件を進めているなら——投稿してほしい。第三章「オールイン者列伝」は更新を続け、選ばれた物語はオンチェーンとこの宣言に永久に保存される。トークンプールの 10% を選出者へ充てる。だが正直に言う：**このプロジェクトに本気で惹かれる人は、その 10% のために来るのではない——記録されるために来る**。',
            '記録されること。それは古い形の報酬だ。トークンよりずっと古く、おそらくずっと持続する。',
          ],
        },
      ],
    },

    {
      id: 'ch3',
      kind: 'chapter',
      number: 'III',
      title: 'オールイン者列伝',
      paragraphs: [
        'この章は崇拝のためではない。',
        'この九人を神格化したいのではない——皆それぞれに限界、論争、過誤がある。任正非は「狼性」で知られるが従業員を酷使したこともある。段永平は時に判断を誤る。マスクの X 買収は今も論争の的だ。孫宇晨の多くのビジネス判断は SEC に提訴されている。',
        '私たちが残したいのは彼ら自身ではなく、彼らがある具体的な瞬間に下した「オールイン」の決断だ。その瞬間、彼らは皆、崖の縁に立ち、すべてのチップを押し出した。その瞬間の勇気、その瞬間の判断、「見極めたから、躊躇しない」というその瞬間の姿勢——これらが残したいものだ。',
        '九人。九つの異なる業界。九つの異なる賭け。だが彼らは一つの姿勢を共有している。',
        '時系列で並べる——1987 年の深圳南油から、2017 年のカメラの前まで。',
      ],
      subsections: [
        {
          id: 'ch3-1',
          number: '01',
          title: '任正非 · 2.1万元の出発（1987）',
          paragraphs: [
            '1944 年、貴州の山間部に生まれる。任正非は中学教師の家庭の長男で、子は七人、収入は薄かった。文革が始まると、父親は「右派」嫌疑で批判、隔離、強制労働の対象となった。長男として弟妹を養う責任を背負った。後に振り返って言う——18 歳で重慶建築工程学院へ進学するまで「腹いっぱい食べたことがなかった」。',
            '1968 年に大学を卒業し、軍の基幹建設工兵部隊に配属、エンジニアとなる。14 年間の軍務で、平の技術者から副連隊級まで上がった。1983 年、軍の整備改編に伴い、数十万の軍人と共に転業し、深圳南海石油の後勤拠点に配置された。',
            '1987 年のある日、任正非はある取引で 200 万元を騙し取られた——当時の彼にとって何代分もの給料に相当する金額だ。妻は離婚を申し立て、父が貴州で病没した。43 歳。失業、負債、独身、二人の子と老母を養う立場——すべてが同時に襲った。',
            '1987 年 9 月 15 日。深圳南山区南油新村 A3 棟 16 階 16D。80 平米にも満たないアパート。任正非と五人の友人は 21,000 元——うち数千元は親類から借りた——を出し合い、会社を登記した。',
            '社名は「華為」。「中華有為」（中華に為すあり）の略だ。',
            '初年度、華為は構内交換機の販売代理店に過ぎなかった。任正非は自ら営業に走り、契約を交渉し、回収を催促し、機器を据え付けた。深圳の夏は 38 度。彼はワイシャツで一軒一軒の顧客を訪ね歩いた。当時の社員は彼を「骨と皮」と覚えている。',
            'だが代理事業の二年目に、華為の三十年を決める判断を下した：自社開発に踏み切る。',
            '当時、中国の通信市場は「七国八制」に独占されていた——七カ国八種の規格で、すべて西側ブランドだった：Lucent、Nortel、Alcatel、Siemens、Fujitsu、Ericsson、NEC……国産品はほぼ皆無。任正非は代理事業の利益を全部 R&D へ注いだ。',
            '1991 年後半、自社開発の HJD48 が量産化。1993 年、華為は当年の利益全額に相当する 5000 万元を、万門級の交換機 C&C08 に投じた。これも一つのオールインだ——R&D が遅れれば会社は破綻する。',
            '1994 年に C&C08 は量産化に成功。年商は 8 億元を突破。年次総会で任正非は後に何度も引用される一文を口にした——',
          ],
          pullQuote: '「十年のうちに、世界の通信機器産業は三分される——華為はその一つになる。」',
          paragraphsAfterQuote: [
            '任正非のオールインはギャンブル型ではなく、絶境型だった。1987 年の彼に「分散して賭ける」資格はなかった——分散できる金がなかったし、分けられる第二のチャンスもなかった。200 万元の詐欺、負債、離婚、父の死——それらが彼を「一つのことにオールインせざるを得ない」位置へ押し上げた。',
            'だが**どこに**オールインするかは判断の結果だった。1987 年の中国通信業は荒れ地だった——一方には国家の急務（電話普及率は 1% 未満）、他方には事実上ゼロの国産プレイヤー。任正非はそこに 30 年級の窓を見出した：通信網はいったん建つと、更新の速度はインフラと同じくゆっくりで、先発優位は構造的に積み上がる。',
            'C&C08 は彼の二度目の「絶境型」決断だった。1993 年の 5000 万元は、当時 270 名の華為にとって、年間利益全額を一つに賭けることだった。納品が失敗——半年遅れではなく、品質未達——すれば、華為は即座に破綻する。',
            '後年、彼自身が『華為の冬』『北国の春』を書く——一連の社内講話、すべてが一つの主題を巡る：**危機感こそが華為の唯一の堀である**。',
            '1996 年に海外進出。2002 年に欧州。2010 年に世界第二位の通信機器ベンダー。2018 年、Ericsson を抜いて第一位に。2018 年 12 月、孟晩舟がカナダで拘束され、米国による華為への制裁が始まる。2020 年に規制は強化、TSMC からのチップ供給が断たれ、スマートフォン事業は一時 70% の収入を失った。',
            '社内講話で任正非はただ二文を残した。「最も困難な瞬間はまだ先にある。」「涙を拭いて、進み続けよう。」',
            '2023 年 8 月 29 日、Huawei Mate 60 Pro が予告なしに発売。完全自社開発の Kirin 9000s チップを搭載。海外メディアは騒然となった——殺されたと見なされていた華為のチップ設計能力が、国産プロセスで蘇っていた。',
          ],
          checklist: {
            items: [
              '**絶境型のオールインは最も純粋だ**——退路がないから、躊躇もない。',
              '**43 歳の起業は遅くない**——「年齢の優位」を取り去ったあとに残るのは判断力と粘り強さだ。それらは年齢で消えない。',
              '**30 年級のトラックを選ぶ**——通信、電力、医療。更新サイクルが長い業界では、先発優位が積み上がる。',
              '**危機感が堀になる**——任正非が 30 年で示したのは、本当に危険なのは危機ではなく、危機感の不在だということだ。',
            ],
          },
        },

        {
          id: 'ch3-2',
          number: '02',
          title: '段永平 · NetEase 底値拾い（2001）',
          paragraphs: [
            '1961 年、江西省南昌生まれ。1989 年、28 歳の段永平は広東省中山の倒産寸前の小さな工場——日華電子廠——に加わった。最初に手をつけたのは、工場が抱えていた 8 ビットのファミコン互換機を「小覇王（Subor）学習機」として包み直すことだった。1992 年にジャッキー・チェンを起用：「Subor 一台で、マイコン教室がまるごと手に入る」。広告費 5,000 万元——当時の中国全土の TV 広告予算の端数のようなものだ。',
            '1995 年、Subor の年商は 10 億元に達する。だが段永平は経営者と持株改革を交渉し、拒まれた。彼はコアチームを連れて離れ、東莞で「BBK（步步高）」を立ち上げた——コードレス電話、リピーター、DVD、後に音楽ケータイ。同じくジャッキー・チェン、同じマーケティング、同じキャッシュカウだった。',
            '2001 年、40 歳の段永平は BBK の経営をチームに委ね、自らはシリコンバレーへ移住した。「半引退」のつもりだった——読書、ゴルフ、投資の研究。',
            '2001 年は dot-com 崩壊の最も酷い年だった。Nasdaq は 5,048 から 1,100 へ。米国上場の中国概念株は壊滅的な打撃を受けた。',
            'NetEase（NTES）は中でも最悪の落ち込みだった。2001 年 7 月、2000 年の年報の記載不正で SEC の調査を受け、株価は IPO 時の 15 ドルから 9 月には 0.6 ドルへ——96% の下落。取引再開後も、ほぼ誰も触れなかった。',
            '段永平は米国に着いて間もなく、米株を研究し始めた。NetEase の財務を覗くと——',
          ],
          list: {
            items: [
              '会社の手元現金 4,400 万ドル',
              '当時の時価総額は 2,000 万ドル未満',
              '主要事業（MMO『大話西遊 II』、メール、広告）すべてプラスのキャッシュフロー',
              '創業者の丁磊が 50% を保有、本人は逃げていない',
            ],
          },
          paragraphsAfterList: [
            '一文で言えば——**会社の現金が時価総額を上回っている**。買うとは、50 セントで 1 ドルの現金を買うようなものだ。',
            '段永平は 200 万ドルを NetEase に投じた。',
          ],
          pullQuote: '「私はインターネットを深く理解しているわけではない。だが人間性については十分に理解している。」',
          paragraphsAfterQuote: [
            '彼の論理はシンプルだ。第一、これは典型的な「安全マージン」の事例だ——明日 NetEase が閉鎖しても、清算後に株主が取り戻す金は株価を上回る。下方リスクは現金で封じられている。第二、丁磊は知り合いだった——BBK 時代に丁磊と取引があり、逃げる人物ではないと信じていた。第三、丁磊はチームを率いて『夢幻西遊』を作っており、現金、チーム、製品方向はあった。欠けていたのは市場のセンチメントだけだった。',
            '段永平は後に言った：「私は NetEase が必ず上がると賭けたのではない——ゼロになっても受け入れる、と賭けたのだ。」',
            'ポジションサイズも重要だ。200 万ドルは彼の全資産ではないが、単一銘柄としては最大級の一つだった。これは分散の「安全マージン」ではない——研究を経た上での集中投資だった。',
            '2003 年初頭、『夢幻西遊』が稼働、たちまち中国で最も国民的なクライアント MMO となった。NetEase の株価は 0.6 ドルから 70 ドルへ——18 ヶ月で 100 倍。段永平の 200 万ドルは約 2 億ドルになった。だが彼は売らなかった。20 年以上保有を続け、徐々に減らしながらも全売却はしていない。',
            '二度目のオールインは 2011 年。ジョブズが亡くなり、市場は Apple が魂を失うのではと懸念し、株価が反落した。段永平は Apple を大量に買い込んだ。理由：「Apple の iOS エコシステム、製品哲学、ユーザーの粘着性は、一人がいなくなっても消えない。」 10 年後、Apple の株価は彼の平均取得から 3〜4 倍になった。',
            'その間に小さな賭けもあった——2010 年代の Tencent、2018 年の貴州茅台。どれも研究を尽くしたうえでの大きな賭けで、分散ギャンブルは一度もない。',
          ],
          checklist: {
            items: [
              '**現金が時価総額を超える銘柄は神レベルの安全マージン**。一生のうち五度も出会わない。出会ったら少額にしてはいけない。',
              '**「やらないリスト」は to-do より重要だ**。やらない領域、知らない業界、理解できないビジネスモデルを排除し、残ったものだけを研究範囲にせよ。',
              '**大きく賭けて長く持つ方が、短期回転より儲かる**。段永平の人生で本当に大きな決断は 5 つを超えない。だがどれも大きく、ビジネス自体が変わるまで保持した。',
              '**バリュー投資は集中と矛盾しない**。バフェットも段永平も集中派だ。「分散は無知者の避難所」——バフェット原文。',
            ],
          },
        },

        {
          id: 'ch3-3',
          number: '03',
          title: 'マスク · 第四回打ち上げ（2008）',
          paragraphs: [
            '1971 年、南アフリカのプレトリア生まれ。10 歳で初めてのコンピューターを手にし、12 歳で Blastar というゲームを 500 ドルで売った。17 歳で南アフリカを離れカナダへ——徴兵を避けるためでもあった。',
            '1995 年、24 歳のマスクはスタンフォードで物理博士課程に入学するが、二日後に中退して弟と Zip2 を始めた。1999 年、Zip2 を Compaq へ売却、彼の手取りは 2,200 万ドル。同年、ほぼ全額を投じてオンライン銀行 X.com を立ち上げ、後に Confinity と合併、PayPal となる。2002 年、eBay が PayPal を買収、最大の個人株主だったマスクは 1.8 億ドルを得た。',
            'もし「分散投資」や「早期リタイア」を選んでいたら、31 歳のまま生涯エンジェル投資家でいられた。だが彼は反対のことをした。',
            '2002 年 6 月、1 億ドルで SpaceX を創業。2004 年、残りの 7,000 万ドルで Tesla に出資し、CEO となる。2006 年、SolarCity の共同設立に関与。',
            '2008 年、三社すべてが破綻寸前だった。',
            '2008 年はマスクの人生でゼロに最も近づいた年だ。SpaceX は Falcon 1 を三度打ち上げ、すべて失敗していた：',
          ],
          list: {
            items: [
              '2006 年 3 月 24 日：打ち上げ 33 秒後、燃料配管から漏出、ロケット墜落',
              '2007 年 3 月 21 日：第一段と第二段の分離時に衝突、制御を失う',
              '2008 年 8 月 3 日：第二段が早期停止、ペイロードが軌道に乗らず',
            ],
          },
          paragraphsAfterList: [
            'SpaceX の手元資金は、もう一度だけ打ち上げられる金額しかなかった。',
            'Tesla の状況はさらに悪かった。Roadster は一年以上の遅延、工場建設の超過、2008 年金融危機で VC のサイフは閉じた。Tesla はその月の給与を払う現金もなかった。',
            'マスクの 1.8 億ドル——PayPal 売却後に得た全額——は、すでに二社に投じられ、自身が燃やした数千万ドルが上に乗っていた。2008 年 9 月のインタビューで彼は言った：「いま手元に残っているのは、妻の車と子どもの学費基金だけだ。」',
            'その秋、彼は決断した：最後の 3,000 万ドル——彼が動かせる現金のすべて——を SpaceX の第四回打ち上げに投じる。',
            '2008 年 9 月 28 日、Falcon 1 第四回打ち上げ。今回は成功した。Falcon 1 は、民間企業が開発し軌道に乗せた、人類で最初の液体燃料ロケットとなる。続いて 2008 年 12 月 23 日（クリスマスの二日前）、NASA は SpaceX に 16 億ドルの輸送契約を出した。同時期、Tesla は 12 月末に 4,000 万ドルの D ラウンドを締結、マスクが結婚指輪と家を担保に借りた 2,000 万ドルを足し、Tesla はそのクリスマスを越えた。',
          ],
          pullQuote: '「このロケットを飛ばすか、この会社が死ぬか。第三の選択肢はない。」',
          paragraphsAfterQuote: [
            '2008 年 9 月のオールイン点で、マスクの選択肢は三つあった：A. 3,000 万ドルを三社に分ける。B. 自動車市場のほうが大きいから Tesla に全額。C. SpaceX 第四発に全額、一回の成功に賭ける。',
            '彼は C を選んだ。理由は三つ。',
            '第一、**SpaceX の数学は確定的だった**。ロケットの失敗モードは有限で、前三回の原因はすべて修正済み。第四回の勝率は計算可能だった。Tesla の市場反応、消費者受容、金融環境——これらは計算できなかった。',
            '第二、**SpaceX が成功すれば、即座に NASA 契約が解放される**。これは「勝てば賞金がすでに来ている」種類の賭けだった。マスクは 2008 年初に NASA と COTS 協定に調印済み——打ち上げ成功で支払いがアンロックされる。',
            '第三、**Tesla には資金調達の余地が残っていたが、SpaceX にはなかった**。VC はロケットに投資しない。SpaceX は自己証明（一回の成功打ち上げ）でしかこの状況を変えられない。',
            '2024 年時点で、SpaceX の評価額は 4,000 億ドルを超え（世界で最も価値のある未公開企業）、Tesla の時価総額ピークは 1.5 兆ドルを超えた。だがすべては「オールインが成功した後の話」だ。もし 2008 年 9 月 28 日の打ち上げが失敗していたら、誰も SpaceX を覚えていないし、Tesla は 2009 年初に破綻していた。',
          ],
          checklist: {
            items: [
              '**計算できる賭けは集中させていい**。マスクが 2008 年に SpaceX に全額入れられたのは、第四回打ち上げのすべての失敗モードを列挙でき、それぞれに対策があったからだ。',
              '**「一度の成功でルールが変わる」事に賭けろ**。NASA 契約は頭上に吊られた賞金だった。マスクは一度の成功でいくらアンロックされるかを知っていた。',
              '**結婚指輪は担保にできるが、時間は担保にできない**。現金が足りないとき資産は換金できる。だが時間が足りないとき、代わるものは何もない。',
              '**「オールイン」は一度きりの出来事ではない**。2008 年のオールインの後、2018 年の Tesla 量産危機で再びオールイン、2022 年の Twitter 買収でまたオールイン。',
            ],
          },
        },

        {
          id: 'ch3-4',
          number: '04',
          title: '雷軍 · 一杯の小米粥（2010）',
          paragraphs: [
            '雷軍は 1969 年、湖北省仙桃に生まれた。両親はともに普通の教師。1987 年、武漢大学コンピュータ学科に入学。3 年生（1989 年）に同級生と組んで BBS ソフトのコピー版を作る、最初の起業。1991 年、22 歳で金山（Kingsoft）の求伯君と知り合い、金山に加わる。1998 年、29 歳で金山 CEO に就任。',
            '金山での 16 年間、彼はチームを率いて WPS、詞霸、毒霸、剣俠情縁などをリリースした——だが Microsoft との対決には勝てず、金山は中国ソフトウェア業界で常に「二番手」だった。',
            '2007 年 10 月 9 日、金山が香港証券取引所に上場。雷軍は健康上の理由（過剰なストレスによる不整脈）で CEO を降り、副会長へ。38 歳、経済的自由を得て、半引退の準備をしていた。',
            '続く三年（2007–2010）、彼は中国の初期最も活発なエンジェル投資家の一人となる。UC Browser、Vancl、YY、Duokan、Keniu、Letao など十数社へ投資した——UC だけでもリターンは 30 億元を超える。',
            'だが 40 歳直前、彼は焦り始めた。',
            '2010 年 4 月 6 日、北京・中関村銀谷ビル 807 号室。雷軍と六人の共同創業者——林斌、黎万強、周光平、劉徳、黄江吉、洪鋒——七人が一つのテーブルを囲んだ。雷軍は七つの椀を運んできた。中身は小米粥（粟粥）。それぞれが一杯飲み、そこから動き始めた。',
            '社名は「Xiaomi（小米）」。「小米加歩槍」——農村が都市を包囲する戦術——の含意と、「米粒級」の細部こそが製品作りだ、という思想を兼ねている。',
          ],
          pullQuote: '「もし起業しなければ、40歳以降の自分にどう向き合えばいいか分からない。」',
          paragraphsAfterQuote: [
            'エンジェル投資の仕事は「広く撒いて確率を取る」ことだ。2007〜2010 年の雷軍は、中国で最も儲けたエンジェルの一人だった。続けていれば、毎年寝ていても十数億の収益は確定だった。なぜその快適な生活を捨てたのか？',
            'インタビューで雷軍は何度も語っている。「私は 18 年間プログラマーをやり、16 年間金山の CEO をやった。一生で最も悔やんでいるのは、世界級の製品を作れなかったことだ。私はビル・ゲイツと同時代を生き、ジョブズと同時代を生き、ラリー・ペイジと同時代を生きた。だが Windows を作っていない。iPhone を作っていない。Google を作っていない。」',
            '彼の判断はこうだ：**モバイルインターネットは 30 年級の窓だ**。iPhone は 2007 年、Android は 2008 年にオープンソース、2010 年は中国がフィーチャーフォンからスマートフォンへ切り替わる転換点だ。この波を逃せば、次のチャンスは 20 年待たねばならない。**ハードウェア企業をインターネット流で作ること**は、中国独自のチャンスだ——最も完備した電子サプライチェーン（深圳）、最大の人口、最も安価な販路（ネット直販）。',
            '全部を賭けるのは、計算が立っていたからだ。エンジェル投資は分散できるが、世界級の会社を一つ作るならオールインしかない。「製品を作る人間が、こっちもあっちもやれない。」',
            '2011 年 8 月 16 日、Xiaomi Phone 1 を発表。1,999 元、デュアルコア、4 インチ画面——同価格帯の競合をすべて上回る仕様。最初の販売、30 万台が数分で完売。',
            '2018 年 7 月 9 日、Xiaomi が香港で上場、時価総額 540 億ドル。当日の演説から流れた一文：「風の向きが合えば、豚でも飛べる。」',
            '2024 年、55 歳の雷軍は EV「Xiaomi SU7」を発表する——これが二度目のオールインだった。Xiaomi は再び千億ドル級の時価総額に戻り、雷軍は中国インターネット新世代の「トラフィックの頂点」となった。',
          ],
          checklist: {
            items: [
              '**経済的自由は終点ではなく、次のオールインの起点だ**。本物の長期主義者は、常に「次に最も重要な一件」にオールインする。',
              '**エンジェル投資と起業は両立しない**。前者は広さ、後者は深さ。雷軍は「投資家もやりつつ CEO」をやらなかった——投資家のアイデンティティを清算した。',
              '**トラックよりも窓を読むことが重要だ**。雷軍はスマホのチャンスを見た最初の人ではない。だが 2010 年の時点でオールインに踏み切った数少ない一人だった。',
              '**40 歳の起業は遅くない、ただしオールインでなければならない**。任正非 43 歳、雷軍 41 歳、王興 33 歳——全部を押し出すとき、年齢は数字でしかない。',
            ],
          },
        },

        {
          id: 'ch3-5',
          number: '05',
          title: '王興 · 千共同購入戦争の最終便（2012）',
          paragraphs: [
            '1979 年、福建省龍岩生まれ。1996 年、龍岩一中から清華大学電子工程学科へ。2001 年に清華を卒業、米国の University of Delaware に進学。博士課程を半分まで進めて 2003 年に中退、帰国して起業した。',
            '王興の最初の 8 年は、連続失敗の 8 年だった：',
          ],
          list: {
            items: [
              '2003 年、多多友（Friendster クローン）。失敗。',
              '2004 年、遊子図（写真共有）。失敗。',
              '2005 年、校内網。清華・北大で爆発的に流行、2006 年に陳一舟へ 200 万ドルで売却（後に「人人網」に改名）。',
              '2007 年、飯否（Twitter クローン）。2009 年に敏感な内容で 503 日間停止、ゴールデンウィンドウを逃す。',
              '2008 年、海内（企業向け Facebook）。失敗。',
            ],
          },
          paragraphsAfterList: [
            '2010 年、31 歳の王興はすでに連続起業 8 年、4 度の明らかな失敗。シリコンバレーの同世代の友人の多くはミリオネアになっており、彼はまだ給料のために金を借りていた。',
            '2010 年 3 月 4 日、王興は美団（Meituan）を立ち上げた——Groupon 型の共同購入。だが今回は違った——2010〜2011 年、中国は共同購入の熱狂のさなかで、ピーク時には全国に 5,000 を超える共同購入サイトが乱立した。業界の脚本は決まっていた：ユーザーに補助金、都市拡大、出資調達、また補助金、また拡大。',
            '王興はこの脚本を拒んだ。',
            '彼は三つの違いを実行した。**補助金戦争に乗らない**——競合がすべて「100元購入で 50元割引」をやる中、Meituan は定価＋商家の品質で勝負した。**IT に重投資する**——他社が地上戦、広告、ユーザー補助に金を使う中、Meituan は半分の予算をプラットフォーム開発に投じた。**会計思考**——新都市を開けるかは ROI モデル次第。モデルが通らなければ開かない。',
            '2011 年下半期、共同購入モデルへの市場の評価は熱狂から疑念へと反転した。VC の財布が閉じる。2011 年末には資金繰りが回らない共同購入サイトが倒れ始めた。2012 年は業界で最も酷い年だった。',
          ],
          pullQuote: '「失敗を拒むなら、成功も拒むことになる。」',
          paragraphsAfterQuote: [
            'その年の社内レターで王興は書いた：「私たちは千の共同購入戦争を生き延びた。だが戦争は終わりではない。始まりだ。」その年、Meituan は大規模なリストラもせず、都市撤退もせず、むしろ宅配（外送）事業へ進軍した——彼の次のオールイン点だ。',
            '王興のオールインは「全部を共同購入に賭ける」ことではなかった——「十年走るサービス会社に全部を賭ける」ことだった。資金繰りが厳しい 2011〜2012 年、彼は反直感的な決断を下した：**運営現金を 2 ヶ月分だけ残し、残りはすべてチームとシステムに投じる**。',
            '競合のやり方は——口座に 6 ヶ月分の現金がある、ならば 5 ヶ月で補助金を燃やしてユーザーを取り、残り 1 ヶ月で再び調達する。失敗すれば、会社は死ぬ。',
            '王興のやり方は——口座に 6 ヶ月分の現金がある、2 ヶ月分を救命に取っておき、4 ヶ月で人を雇い、システムを作り、土台を打つ。調達に失敗しても、会社はあと 2 ヶ月生きられる——その 2 ヶ月でさらに製品とサービスを磨き、次の機会を待つ。',
            'これは保守的に聞こえるが、本質はもう一つのオールインだ——**「長期主義」という判断にオールインしている**。',
            '2013 年、Meituan は宅配事業へ。2015 年 10 月、大衆点評と統合。2017 年、ライドシェアへ。2018 年 9 月 20 日、香港上場、時価総額 4,000 億香港ドル。2020 年のパンデミックで宅配の浸透率が急騰、時価総額のピークは 2,000 億ドルを超えた。',
          ],
          checklist: {
            items: [
              '**九敗一勝**——一度しか勝てないなら、勝つときは徹底的に勝て。',
              '**現金は使うためではなく、耐えるためにある**。戦場が見える前に、「見えるまで耐えられる」だけのバッファを残しておけ。',
              '**相手が得意なゲームに付き合うな**。皆が金を燃やしているとき、君は冷静に製品を磨け。皆が製品を磨くとき、君は冷静に販路を打て。常に「相手の最も弱い次元」でオールインせよ。',
              '**長期主義そのものが一つの賭けだ**。王興は「共同購入が勝つ」に賭けたのではなく、「10 年でやる人が勝つ」に賭けた。',
            ],
          },
        },

        {
          id: 'ch3-6',
          number: '06',
          title: '趙長鵬 · 家を売ってビットコイン（2014）',
          paragraphs: [
            '趙長鵬（CZ）は 1977 年、江蘇省連雲港生まれ。父親は大学教師、政治的理由で僻地へ送られ、1989 年に家族でカナダ・バンクーバーへ移民。',
            'カナダでの少年時代、CZ はマクドナルドでバイトし、ガソリンスタンドの夜勤、東京の寿司店での見習い——典型的な「貧しい移民二世」だった。1996 年、マギル大学コンピュータ学科に入学。卒業後、Bloomberg の取引システムエンジニアとなる。2005 年、Bloomberg を離れ起業、Fusion Systems という高頻度取引システムを開発、顧客はウォール街のヘッジファンドだった。',
            '2013 年のある日、CZ は友人と夕食を共にした。その友人は食事の間ずっとビットコインの話をした。CZ の当時の反応は——まったく理解できない。',
            'だが数日後、彼はビットコインのホワイトペーパーを読んだ。さらに数日で、Andreas Antonopoulos の『Mastering Bitcoin』を読み終えた。さらに数週後、彼は上海へ飛び、OKCoin（徐明星のところ）を訪ね、入りたいと告げた。',
            '2014 年、CZ は上海に一軒の不動産を持っていた（具体的な場所は未公表、市内中心部と推測される）。彼はそれを売却した。資金を全部ビットコインに換えた。',
            '2014 年のビットコイン価格は 200〜700 ドルで推移していた（年初 800、年央 600、年末 320）。彼は購入平均価格を公表していないが、2014 年の中央値で推定すると 1,000〜3,000 BTC ほど買ったことになる。',
            '2014 年当時、これを知っていた人はほとんどいなかった。2018 年のインタビューで「最もオールインだった決断は？」と問われ、彼はこう答えた：「2014 年に上海の家を売って、全部をビットコインに換えた。」',
          ],
          pullQuote: '「私が賭けたのはビットコインの値上がりではない。賭けたのは——暗号資産が金融インフラを書き換えるということが、必ず起こるという一点だ。」',
          paragraphsAfterQuote: [
            '「——5 年かもしれないし、10 年かもしれない、20 年かもしれない。だが必ず起こる。起これば、ビットコインはこの新世界で最も確かな資産だ。起こらなければ、家を寄付したと思おう。」',
            'すでに OKCoin で働いており、2015 年には Blockchain.info に移った。彼はトレーダーではない——インフラを建てる人間だ。',
            '2017 年 5 月、CZ は OKCoin を離れた。6 月 26 日、Binance の ICO 開始、1,500 万ドル調達。7 月 14 日、Binance 取引所が正式稼働。社員 11 人。シンプルなウェブサイト。シンプルな約束：低手数料、多通貨ペア、技術的安定。',
            '2017 年 9 月 4 日、中国 7 部委が共同で「トークン発行融資のリスク防止に関する公告」を発表、ICO と暗号資産取引所を全面禁止。Binance は稼働 2 ヶ月で生死の瀬戸際に立った。',
            'CZ の反応は——その晩のうちに日本へ。3 日でチーム全員を東京、香港、マルタ、シンガポールへ分散。Binance は「無国籍」企業となった。2017 年末、Binance の DAU は 600 万を超え、世界最大の暗号資産取引所となった。立ち上げから 180 日未満で世界一。',
            '2014 年の家売却と 2017 年の Binance は、同じ思考の二度の実行だ。**「インフラ」に賭けて「価格」に賭けない**——CZ はビットコインが 10 万ドルになるとは一度も言っていない。「暗号資産の金融インフラは必ず建てられる」とだけ言った。**皆が規制を恐れているとき、規制裁定にオールイン**——2017 年の中国禁令は Binance にとって最大の脅威ではなく最大の機会だった。**「無国籍」を競争力にする**——Binance は初日から 8 カ国の社員、4 言語のカスタマーサポート、30+ の法定通貨入金経路を備えていた。',
            '2022 年 11 月 8 日、FTX 崩壊、CZ は救済を拒否し SBF の失墜を加速させる。Binance はその勢いで市場を取り込んだ。2023 年 11 月 21 日、米国司法省が Binance と CZ の認諾と 43 億ドルの罰金を発表。CZ は CEO を辞任、4 ヶ月の収監。2024 年 4 月に出所、後半には再び活動的になり、Binance は依然として世界最大の取引所だ。',
          ],
          checklist: {
            items: [
              '**家を売った人間は引き返さない**。CZ は 2014 年の売却以降、「いつか抜けたければ戻れる」退路を失った——自分で自分を縛った。この自縛こそ、最大の実行力の源だ。',
              '**長期の物語に賭けて、短期の価格には賭けない**。BTC は 2014 年から 2024 年で 100 倍になった。だが「10 倍で売る」目的で買っていたら、CZ はとっくに退場していた。「私は売らない」で買うことこそ、本物のオールインだ。',
              '**規制は機会であって脅威ではない**。大きな規制イベントのたびに、「半信半疑」のプレイヤーが退場し、「完全に信じる」プレイヤーが市場全体を取る。',
              '**インフラ > 資産価格**。CZ は BTC の上昇幅に賭けたのではなく、「暗号資産取引所」というインフラの位置に賭けた。結果、BTC は 100 倍、Binance は 1,000 倍。',
            ],
          },
        },

        {
          id: 'ch3-7',
          number: '07',
          title: 'コリン・ホアン · 三度のリスタート（2015）',
          paragraphs: [
            '1980 年、浙江省杭州生まれ。両親はともに普通の労働者。子どもの頃から成績が良く、1998 年に推薦で杭州外国語学校（杭外）に入った。そこである人物と出会う——段永平。校内イベントで知り合い、当時すでに BBK の経営者だった段は母校に客員として戻っていた。',
            '2002 年、浙江大学コンピュータ学科卒業。コリン・ホアン（黄崢）は段永平の支援で University of Wisconsin–Madison のコンピュータ修士へ。2004 年に修了し、Google 中国の初期チームに加わる。',
            '2006 年、Google でバフェットチャリティーランチのオークション入札に関わった段永平が 62 万ドルでチケットを落とし、コリンを連れてバフェットとマンガーに会いに行った——コリンのビジネス人生で最も重要な授業だった。',
            '2007 年、27 歳でコリンは Google を離れ、最初の起業：欧酷網。2009 年に 4,500 万ドルでランティン・コレクション（蘭亭集勢）へ売却。2009 年に二度目の起業：樂其運営代理（P&G、ユニリーバなどの EC 代理運営）。2013 年に三度目の起業：尋夢ゲーム。',
            '2015 年、35 歳のコリンはすでに三社を立ち上げていた：欧酷（売却）、樂其（黒字運営）、尋夢（黒字運営）。手元には金、チーム、リソース。三社をそのまま続ければ、生涯安泰だった。だが彼は四度目のリスタートを切った。',
            '2015 年 9 月、コリンは同時に二つの新プロジェクトを孵化した：拼好貨（生鮮 EC）と拼多多（雑貨 EC）。2016 年 9 月に「拼多多」へ統合。',
            'なぜ共同購入か。なぜ下沉市場か。',
            '2015 年の中国 EC は JD と Alibaba の二強体制で、業界からは「もう起業の余地はない」と見られていた。コリンの見方は違った——「JD と Alibaba が相手にしているのは中国の都市部 5 億人だ。残る農村と三・四線都市の 5 億人の需要と購買力は、誰もまともに相手にしていない。」',
          ],
          pullQuote: '「常識を保ち、喧騒から遠ざかる。」',
          paragraphsAfterQuote: [
            '拼多多の設計：**共同購入**——ソーシャル関係で拡散させ、獲客コストを極限まで下げる。**WeChat エコシステム**——独立 App を作らず、WeChat の中に寄生する。**ノーブランド商品**——ブランド品を売らず、工場直販を売る。価格は JD/Taobao の半分。**アルゴリズム配信**——検索ではなくレコメンドで、ユーザーに「スワイプ」させる。',
            'これらの選択はどれも同業者から嘲笑された。「拼夕夕」「偽物」「品が悪い」——拼多多は三年間罵られ続けた。だがユーザーは増え続けた。2017 年、拼多多の年間 GMV は 1,000 億元を超える。',
            'コリンのオールインは「商業的常識」を、嘲笑される方向へ全部押し出すことだった。**主流市場に賭けない**——皆が北京・上海・広州・深圳のエリート層を見ているとき、彼は五環外の人口に賭けた。**反 App 思考**——皆が独立 App を作っているとき、彼は WeChat エコに賭けた。**反ブランド思考**——皆が「消費アップグレード」を語るとき、彼は「消費ダウングレード」に賭けた。**反検索思考**——皆が検索ボックスで配信するとき、彼はアルゴリズムレコメンドに賭けた。',
            'すべてが反主流だった。すべてが「インターネット原住民ではない人々」への深い洞察に基づいていた。',
            'そして彼には「段永平 → バフェット → マンガー」の三層の師がいた。三人は彼に同じことを教えた：**自分の論理が主流と逆向きのとき、まず「自分は何を見落としているか」を問え。問い終えてもなお元の判断を保つなら、オールインしろ**。',
            '2018 年 7 月 26 日、拼多多は Nasdaq に上場、時価総額 240 億ドル。当日コリンは 38 歳。2020〜2021 年、拼多多 GMV は一時的に JD を超えた。2024 年、時価総額のピークは 2,200 億ドルを超え、海外ブランド Temu は米国で Amazon に挑む。',
            '2021 年 3 月、41 歳のコリンは CEO 退任を発表、生命科学と食品科学の研究へと進んだ。公開書簡で言う：「私は疲れた。残りの人生は、本当に好奇心がある問題に使いたい。」',
          ],
          checklist: {
            items: [
              '**リスタートは恥ではない**。35 歳のコリンはすでに三社を経営していたが、「経路依存に居続ける」道を選ばなかった。毎回自問した：「これは 10 年後もやりたいことか？」',
              '**反主流の判断ほど深い研究が必要だ**。結論が皆と違うなら、見落としているものを見たか、見間違えたかのどちらかだ。「自分はどこを誤っている可能性があるか」を何度も問え。',
              '**師の複利**。段永平 → バフェット → マンガー、三層の師がコリンに価値投資の世界観を完全に伝達した。重要な決断のとき、他人の 50 年分の知恵を借りられる。',
              '**退場は入場より難しい**。41 歳のコリンの引退と科学研究への移行は、別の意味でのオールインだ——人生後半を、すぐにはリターンが出ないことに賭けた。',
            ],
          },
        },

        {
          id: 'ch3-8',
          number: '08',
          title: '張一鳴 · TikTok の海外進出（2016）',
          paragraphs: [
            '1983 年、福建省龍岩生まれ。王興と同郷で、ともに龍岩一中の出身。父親は機関幹部、母親は看護師。',
            '2001 年、南開大学マイクロエレクトロニクス専攻に入学。ソフトウェアにより興味を持ち、2003 年にソフトウェア工学へ専攻変更。在学中、コンピュータの古典をほぼすべて読破し、オープンソースへの貢献も始めた。',
            '2005 年卒業。2005〜2009 年、IBM インターン（退屈で辞職）、酷訊旅行検索（一年でエンジニアからテックリードへ）、飯否（王興の二社目）、九九房（自身の起業）と数社を渡り歩いた。',
            '2011 年、28 歳の張一鳴はすでに 4 社、3 度の明らかな失敗を経ていた。彼は一つの問いを反芻していた：**なぜインターネット業界の内容配信は、いまだに編集者推薦のままなのか？**',
            '2012 年 3 月 9 日、ByteDance を設立。同年 8 月、Toutiao（今日頭条）1.0 がローンチ。',
            'Toutiao の中核イノベーションは——**アルゴリズム推薦であって、編集者推薦ではない**こと。これは 2012 年の中国では異端だった。当時のすべての内容プラットフォーム——新浪、網易、捜狐、騰訊——は編集者が選稿し、トップに置き、ユーザーが受動的に見る形だった。アルゴリズム推薦は「低俗」「クリックベイトの温床」「機械にコンテンツは理解できない」と見なされていた。',
            '張一鳴の判断：アルゴリズム + データ = 編集者よりユーザーを理解する。',
            'だが最初の二年は順風ではなかった。2012〜2013 年、Toutiao の成長は遅く、調達も数十回断られた（ほとんどの VC はアルゴリズム推薦が主流になることを信じなかった）。2014 年 6 月、セコイアが Toutiao の C ラウンドを 5 億ドル評価でリードし、アルゴリズム路線への最初の大きな賭け手となった。2014〜2016 年、Toutiao は爆発期。MAU は 1,000 万から 1.5 億へ。',
            '2016 年 9 月、ByteDance がショートビデオ App をローンチ、改名して「Douyin（抖音）」となる。2017 年に Douyin の DAU は 5,000 万を突破、2018 年に 2 億を突破。',
            'だが、より決定的な判断は海外進出だった。',
            '2017 年 11 月、ByteDance は 10 億ドルで Musical.ly を買収。2018 年 8 月、Musical.ly と海外版 Douyin を統合し、TikTok に。',
            '当時、ByteDance の手元現金は 30 億ドル未満。10 億ドルの買収は、口座の 1/3 を「成功するか誰にも分からない一件」に賭けることだった——中国 App が欧米 C 端市場に上陸して成功した例は一度もなかった（WeChat、QQ も海外で失敗していた）。',
            '張一鳴はそこから 5 年、ByteDance のリソースと人材の 70% を TikTok に傾けた。',
          ],
          pullQuote: '「遅延満足感とは、人生を無限のゲームとしてプレイする能力である。」',
          paragraphsAfterQuote: [
            '張一鳴の「遅延満足感」哲学が最も鮮やかに現れたのが、海外進出だった。2016〜2017 年の中国インターネットでは、皆が「BAT 以外の国内紅利」を奪いに走っていた。だが張は判断した：',
            '第一、**国内市場の天井は十分高くない**。Toutiao はすでに中国で 1.5 億 MAU、伸びしろは限られていた。',
            '第二、**アルゴリズム + ショートビデオ + レコメンドフィードは普遍的なコンテンツ製品だ**。この組み合わせは中国国情に依存しない。理論上、世界中で使える。',
            '第三、**中国インターネット企業で、C 端で本当に欧米を取った会社は存在しない**。誰かが取れるなら、その世代最大の紅利になる。',
            '第四、**海外進出が賭けているのは市場シェアではなく、発言権だ**。中国企業が米国で 1 億ユーザーを取るのは、新冷戦時代の「ソフトパワー兵器」を持つことに等しい。',
            'リソースの 70% を不確実な一件に投じるのは、「遅延満足感」を信じる人にしかできない。',
            '2019 年、TikTok の米国 DAU は 4,000 万を突破。2020 年、トランプは TikTok 禁止を試みたが最終的に失敗。2021 年、TikTok のグローバル MAU は 10 億を突破。2024 年、ByteDance の評価額は 3,000〜5,000 億ドル（プライベートマーケット）。',
            '2021 年 5 月 20 日、38 歳の張一鳴は CEO 退任を発表、梁汝波が後を継いだ。社内レターでは：「日々の経営から離れて、5〜10 年単位のことを考えたい。」',
          ],
          checklist: {
            items: [
              '**アルゴリズムはこの時代で最も過小評価されている人類の発明だ**。2012 年の張一鳴の判断「アルゴリズム + コンテンツが配信権を再構築する」は、10 年後に兆円規模の判断となった。',
              '**遅延満足感は賭けないことではない、大きく賭けることだ**。「待っている」ように見える人は、いざというときに、他人が想像もしなかった大きさで賭ける。',
              '**国際化は売上の拡張ではなく、製品の遺伝子だ**。初日から世界に向けて設計された製品が、10 年後に世界を取る。中国市場で生まれてから海外を考えた製品は、ほぼ文化の壁で止まる。',
              '**反コンセンサスを 3 度以上重ねた人だけが大事を成す**。アルゴリズム推薦で 2012 年の合意に逆らい、Douyin で 2016 年のショートビデオの合意に逆らい、海外進出で 2017 年の中国インターネットの合意に逆らった。すべて当たった。',
            ],
          },
        },

        {
          id: 'ch3-9',
          number: '09',
          title: 'ジャスティン・サン · カメラの前のオールイン（2017）',
          paragraphs: [
            '1990 年、青海省西寧生まれ。父親は中学の語文（国語）教師。高校から物書きを始め、2007 年に新概念作文一等賞を受賞。2008 年、北京大学歴史学科に入学。2013 年に北大を卒業、米国ペンシルベニア大学で修士課程に進む。',
            '2013 年に Ripple に加わり、大中華地域の代表を務める。2 年後に離れ、独立する。',
            '2017 年 8 月 28 日、27 歳のジャスティン・サン（孫宇晨）は TRON の ICO を立ち上げ、7,000 万ドルを調達。2017 年 9 月 4 日、中国 7 部委が「トークン発行融資のリスク防止に関する公告」を発表。すべての ICO プロジェクトに調達停止と返金が求められた。TRON は最前線にあった。世間の見方はほぼ一致していた——TRON は終わった。',
            'だがジャスティンは伝統的なルートを取らなかった。彼はカメラの前で——複数のライブ配信、複数のインタビューで——明言した：「All In! 個人の全資産が TRON にある。」',
            'これはマーケティングの話術ではない。一つの姿勢だった——退路を完全に焼き払い、迷う可能性のあるすべての投資家とホルダーに見せる：「私には plan B がない。」',
            '2018 年 6 月 25 日、TRON メインネットが正式稼働。同年 7 月、TRON は BitTorrent を買収（1.4 億ドル）、暗号資産界初の大型 M&A となる。',
            '2018 年末、TRON は世界トップ 10 のパブリックチェーン、TRX の流通時価総額のピークは 100 億ドルを超えた。',
          ],
          pullQuote: '「All In!」',
          paragraphsAfterQuote: [
            'ジャスティン・サンのオールインは論争を伴う——業界の評価は二極に分かれる。論争を脇に置いて決断だけを見ると、彼の「All In!」という姿勢自体が、いくつかのことを変えた。',
            '第一、**「梭哈/オールイン」という言葉を中国語圏の暗号資産文脈に固定した**。彼以前、中国語圏での対応語は「梭哈」「重倉」だったが、どれもスローガン化していなかった。彼がカメラの前で「All In!」と叫んだ後、この二語の英語は文化的シンボルとなった。',
            '第二、**「個人 All In」が「チーム All In」に取って代わった**。従来の起業プロジェクトはチームの信用に基づいていたが、TRON はジャスティン・サンという個人の信用に基づいていた。彼の賭けは：「私を信じるなら TRX を持て。信じないなら去れ」。この急進的な「個人化されたコミットメント」は、後の多くの meme と暗号 KOL プロジェクトのテンプレートとなった。',
            '第三、**規制圧力期に逆向きに動く**。2017 年 9 月の禁令の後、合理的な反応は退場、転換、縮小だった。サンの反応は：海外移転、投資増、露出増。この「逆方向 All In」は、2008 年のマスクが第四回打ち上げに賭けたのと同じロジックだ——他人が撤退するとき、君がオールインする。',
            '2019 年 6 月、サンは 457 万ドルでバフェットランチを落札——史上最高額。健康上の理由で延期され、2022 年 5 月に実現した。',
            '2020〜2021 の暗号ブル相場で TRX は大きく上昇、TRON は USDT の主要発行チェーンとなる（ピーク時、TRC20-USDT の流通量は 500 億ドルを超えた）。だが論争は続く。2023 年、SEC がサンを市場操作の疑いで提訴。2022 年にはアルゴリズム型ステーブルコイン USDD のデペッグ危機。',
            '2024〜2025 年の時点で、TRX は依然として世界トップ 10 のトークンの一つ、ジャスティン・サンは依然として暗号資産界で最も話題性のある中国人起業家だ。',
          ],
          checklist: {
            items: [
              '**公にオールインすることは、自縛のコミットメントだ**。カメラの前で「私の全資産はここにある」と口にしたとき、君は引き返せない約束を自分に課す。この自縛そのものが実行力だ。',
              '**「オールイン」という文化的シンボルの力**。一つの言葉、一つのスローガン、一つの姿勢は、ときにビジネスモデル以上にコンセンサスを集める。',
              '**論争 + オールインは共存する**。全部を賭けた人は、必ず論争を伴う。一度も叩かれたことのない起業家は、本当には全部を賭けていないのかもしれない。',
              '**逆方向の動きはオールインの基本姿勢だ**。規制禁令、市場のパニック、世論の包囲——これらの瞬間こそ、オールインの最高のウィンドウだ。',
            ],
          },
        },
      ],
      paragraphsTail: [
        '九つの物語、語り終えた。',
        '本来収録されるべき人をすべて収めたわけではない。この巻は始まりだ——以後、コミュニティ投稿で採用された物語が、この名簿の続きを書いていく。',
        '身近にそういう人がいたら、あるいは自分自身がそういう人なら——投稿してほしい。',
        '長い名簿は、まだ始まったばかりだ。',
      ],
    },

    {
      id: 'ch4',
      kind: 'chapter',
      number: 'IV',
      title: 'コミュニティ共同構築',
      paragraphs: [
        'ALLIN は一人で書ききれるプロジェクトではない。この章では：どう貢献するか、どう収録するか、報酬はどう配分するかを明確にする。',
      ],
      subsections: [
        {
          id: 'ch4-1',
          number: 'i',
          title: '誰が投稿できるか',
          paragraphs: [
            '誰でもオールインの物語を投稿できる。',
            '受け入れる三つのソース：',
          ],
          checklist: {
            items: [
              '**個人の物語**——あなた自身が経験したオールインの瞬間',
              '**目撃者の代筆**——身近な人が経験した、あなたが代わりに書きたい物語',
              '**研究型の投稿**——あなたが研究した公的人物のオールインの瞬間。引用は原典に遡れること',
            ],
          },
          paragraphsTail: [
            '三つ目が現状『オールイン者列伝』の主な源だ。一つ目は急速に増えている——すでに数十件の匿名投稿を受け取り、審査中だ。',
          ],
        },
        {
          id: 'ch4-2',
          number: 'ii',
          title: '採用基準',
          paragraphs: [
            'すべての「All in」がオールインに当たるわけではない。採用基準は厳しい。物語が収録されるには、以下の三条件**すべて**を満たさねばならない：',
          ],
          checklist: {
            items: [
              '**条件一 · 「失っても耐えられる全部」を賭けたこと**——10% は違う。50% も違う。「失敗すれば直ちに実質的な困難に陥る」水準でなければならない——家を売る、口座を空にする、資産を担保にする、安定収入を捨てる、すべての選択肢を断つ。具体的な資産額、収入の途絶、退路の遮断が見えなければならない。',
              '**条件二 · 明確な決断の瞬間があること**——「10 年それをやってきた」はオールインではない。具体的な瞬間が見えなければならない——ある日、ある会議、ある一言、ある署名——決断が下された瞬間。それは「朝、粥を飲んだ瞬間」かもしれないし、「夜、契約に署名した瞬間」かもしれない。だが必ずタイムスタンプであること。',
              '**条件三 · 検証可能な結果があること**——成功でも失敗でも、公開で確認できる「その後」が必要だ：製品が出た、会社が潰れた、時価総額が変わった、資金フローが変わった。失敗の物語も成功と同じだけ価値がある。前提として、失敗そのものが誠実に記録できることだ。',
            ],
          },
          paragraphsTail: [
            '三つは欠かせない。',
            '私たちは「失敗のオールイン」も収録する——こうした物語は埋もれてはならない。全部を賭けて負けた人は、全部を賭けて勝った人と、同じだけの勇気を背負っている。',
          ],
        },
        {
          id: 'ch4-3',
          number: 'iii',
          title: '投稿フローと報酬',
          paragraphs: [
            '日本語で 3,000〜4,000 字の物語を、「背景／決定的瞬間／決断の論理／その後／教訓」の五段で構成する。少なくとも 3 つの公開ソースを引用する（個人の物語は当事者証言＋タイムスタンプでも可。公的人物は新聞、年報、伝記など検証可能な資料を必須とする）。Telegram（@allin_submissions）または GitHub PR（allin/manifesto repo）へ投稿。コミュニティの匿名審査、通常 2〜4 週間で返信。',
            'コミュニティプールはトークン総量の 10%。コントラクト確認後、専用アドレスでロックされる。配分方式：',
          ],
          checklist: {
            items: [
              '採用された物語ごとに、著者へ固定で 30 万 ALLIN の基本報酬',
              '引用／転送／翻訳が 1,000 回ごとに、著者へ追加で 5 万 ALLIN',
              '翻訳者（中→英、中→他言語）は原著者の報酬の 30% を受け取る',
              '最初の 100 件の収録物語の著者には「創世貢献者」のオンチェーン NFT バッジを永久付与',
            ],
          },
          paragraphsTail: [
            '率直に言う：金額は本質ではない。この宣言に収録されること、オンチェーンで永久に記録されること、すべての将来の ALLIN ホルダーに読まれること——これこそが核心の動機だ。',
            'ガバナンスについて：ALLIN は DAO ではなく、「トークン投票でロードマップを決める」ようなショーはやらない。だが以下は行う：採用基準の改訂はコアコミュニティ貢献者の集団討議で。重大判断（将来の調達、CEX 上場の是非）はコミュニティ署名で公示。トークン分配の執行は毎月オンチェーンで公開記録。宣言文の修正提案には 14 日間の公示期間。',
          ],
          pullQuote: '約束は少なく、したら必ず守る。',
        },
      ],
    },

    {
      id: 'ch5',
      kind: 'chapter',
      number: 'V',
      title: 'メカニズムと透明性',
      paragraphs: [
        'この章は本来、長く書ける——チェーン、コントラクト、配分、セキュリティ監査、流動性証明をすべて広げて。だが私たちは短く書くことを選ぶ。',
        'これらはすべてオンチェーンで一目瞭然だからだ。文章で改めて記述する必要はない。',
      ],
      subsections: [
        {
          id: 'ch5-1',
          number: 'i',
          title: '基本情報',
          checklist: {
            items: [
              '**チェーン** · BNB Chain（BSC）',
              '**コントラクトアドレス** · 0x234c3bFC260277cb4497E498A83aB685E30Ac730',
              '**トークン規格** · BEP-20',
              '**総供給量** · 1,000,000,000 ALLIN',
              '**小数桁** · 18',
              '**DEX** · PancakeSwap V2',
              '**取引ペア** · ALLIN/USDT、pair address 0xa6c24770d62b156115198de3fcc9be9e70bf975e',
              '**マーケットデータ** · DexScreener / GeckoTerminal / CMC（順次掲載）',
            ],
          },
        },
        {
          id: 'ch5-2',
          number: 'ii',
          title: 'トークン配分',
          paragraphs: [
            '**公開流動性 85%**——稼働と同時に PancakeSwap へ注入、LP は永久焼却。オンチェーンで証明可能な焼却トランザクションは、コントラクト作成から 24 時間以内に実行。',
            '**コミュニティ報酬 10%**——『オールイン者列伝』の投稿報酬、翻訳報酬、コミュニティ貢献の褒賞に充当。アドレスは公開、毎月オンチェーンで支出を記録。',
            '**マーケティング 5%**——KOL、メディア、コミュニティイベントに充当。アドレス公開、各支出は 24 時間以内に Twitter で告知。',
            '**チーム保有 0%**——ない。私たちは取らない。',
          ],
        },
        {
          id: 'ch5-3',
          number: 'iii',
          title: 'LP 焼却とライブダッシュボード',
          paragraphs: [
            'LP 焼却のトランザクション hash はオンチェーンで検索可能。これがこのプロジェクトで最も重要なトランザクションだ——「プールを引き上げる」能力が私たちにないことを証明する。誰でも BscScan で検証できる：コントラクト作成 → 流動性追加 → LP トークンを 0x000…dead アドレスへ送付。',
            '技術詳細が分からなければ、一つだけ覚えておけばいい：**LP 焼却の後、このトークンのプールは永遠に運営側によって引き上げられない。誰にも引き上げられない**。',
            'トップページの 4 つのライブデータカード——時価総額、ホルダー数、24h 出来高、プール USDT——は DexScreener API + GoPlus Security API から取得し、60 秒ごとに自動更新される。ブラウザの開発者ツールでリクエストを検証できる。異常を見つけたら Telegram で報告してほしい。',
          ],
        },
        {
          id: 'ch5-4',
          number: 'iv',
          title: '私たちにないもの',
          paragraphs: [
            'このトークンが何かを正確に知ってもらうため、「私たちにないもの」も並べる：',
          ],
          checklist: {
            items: [
              '監査はない——コントラクトはあまりに簡素で、60 行以内で読める。標準 BEP-20 + LP 焼却。',
              'ステーキングコントラクトはない',
              'ロックアップ機構はない（LP 永久焼却を除く）',
              'クロスチェーンブリッジはない',
              'ガバナンストークンではない——ALLIN を保有しても投票権はない',
              'エアドロップの約束はない——する予告もないし、後で「突然発表」もしない',
            ],
          },
          paragraphsTail: ['シンプルさが、このトークンの設計原則だ。'],
        },
      ],
    },

    {
      id: 'ch6',
      kind: 'chapter',
      number: 'VI',
      title: 'これは何ではないか',
      paragraphs: [
        'この章は境界を引くためにある。',
        '暗号資産の世界では、新しいトークンが必ず以下の質問にさらされる：L1 か？どんな問題を解決するのか？どんな utility があるのか？某プロジェクトとどう関係するのか？',
        '誰もが二度と尋ねなくて済むよう、直接答えておく。',
      ],
      subsections: [
        {
          id: 'ch6-1',
          number: 'i',
          title: 'ALLIN ではないもの',
          checklist: {
            items: [
              '**L1 ではない**——新しいパブリックチェーンではなく、BNB Chain 上の BEP-20 トークンだ',
              '**DeFi プロトコルではない**——lending / swap / staking / yield のような金融機能は一切ない',
              '**RWA トークンではない**——現実資産の裏付けはない',
              '**ガバナンストークンではない**——保有してもプロジェクトへの投票権はない',
              '**ユーティリティトークンではない**——具体的な「利用シーン」はない。何の機能のロックも解けず、商品も買えず、サービスも得られない',
              '**エアドロップ銘柄ではない**——エアドロップ計画はない。「突然発表」されるエアドロップもない',
              '**いかなるトレンドのつぎはぎでもない**——RWA / IDO / Restaking / DePIN、これらと ALLIN は関係ない',
            ],
          },
        },
        {
          id: 'ch6-2',
          number: 'ii',
          title: 'では ALLIN とは何か',
          paragraphs: [
            'ALLIN は記念碑だ。名簿だ。合言葉だ。',
            'その全価値は、「見極めたらオールイン」という精神への保有者の同意から来る。リターンの約束はなく、実用機能はなく、未来のロードマップもない。',
            '投資対象には聞こえない。その通り、**もともとそうではない**。',
          ],
          pullQuote: 'その価値は金融的なものではなく、文化的なものだ——この精神に共感するなら、買えばいい。共感しないなら、去ればいい。',
        },
        {
          id: 'ch6-3',
          number: 'iii',
          title: 'リスクと司法管轄',
          paragraphs: [
            'このトークンはゼロになり得る。',
            'ある日、ALLIN の市場がこの精神を信じなくなれば、価格はゼロになる。ある日、コミュニティのコンセンサスが崩れれば、価格はゼロになる。ある日、規制がこの種のコミュニティトークンを完全に禁止すれば、価格はゼロになる。',
            '私たちはそのゼロを 100% 知っており、その「ゼロになる可能性」をすべての公開資料に書き込んでいる。',
            '失っても耐えられる金額で賭けてほしい。',
            'ALLIN はいかなる司法管轄区においても証券の募集ではない。本宣言は投資助言、勧誘、申し込みのいずれも構成しない。あなたの居住国・地域が暗号資産の保有を禁じているなら、現地法に従ってほしい。ALLIN は明らかに暗号規制に反する市場へ自ら進出することはない。',
          ],
        },
      ],
    },

    {
      id: 'postscript',
      kind: 'chapter',
      number: '',
      title: 'あとがき',
      paragraphs: [
        'ここまで読んでくれたなら——',
        'あなたは『オールイン宣言』のすべてを知ったことになる。まえがき、なぜ ALLIN なのか、三つの精神原則、九人の物語、コミュニティ共同構築のルール、メカニズムの透明性、そしてこのトークンが何ではないか。',
        'もはや説得しない。',
        'この文章があなたを動かしたなら、テーブルへ来てほしい。ALLIN を少し買い、Telegram コミュニティに参加し、身近なオールインの物語を投稿してほしい。あるいは、何もしなくていい——いま縁で躊躇している友人に、この宣言を一通転送してくれるだけでいい。',
        'この文章があなたを動かさなかったなら、それでいい。これはもとから万人に向けた文章ではない。',
        '私たちが残したいのは、10 億ドルのトークンではない。100 年後も誰かが読んでいる文章だ——この世代で一つのことに全部を賭けた人々を記録し、その瞬間の彼らの勇気を記録し、「オールイン」という言葉が、一度は真剣に、丁寧に、皮肉なく使われたことを記録する。',
      ],
      pullQuote: '記録されることは、古い報酬の形だ。トークンよりずっと古く、おそらくずっと持続する。',
      sign: '——ALLIN コミュニティ、2026 年 春',
    },
  ],
};
